// extracted by mini-css-extract-plugin
module.exports = {"priceTableCollapsed":"price-table-preview_priceTableCollapsed__mbKpq","priceTableNormalHeight":"price-table-preview_priceTableNormalHeight___bvqV"};